import { get, request } from '../core/http';

export interface GetSSOUrlParams {
  state: string;
}

export interface LoginInParams {
  code: string;
}

export interface LoginResult {
  isGuided?: boolean;
  name?: string;
  permissions?: unknown;
  state?: string;
  token?: string;
}

export const loginApi = {
  getSSOUrl(params: GetSSOUrlParams) {
    return get<string, GetSSOUrlParams>('/login/getSSOUrl', params);
  },

  loginIn(params: LoginInParams) {
    return request<LoginResult>({
      url: '/login/loginIn',
      method: 'post',
      params,
    });
  },

  validateLoginToken() {
    return request<void>({
      url: '/login/tokenCheck',
      method: 'get',
    });
  },
};
